import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

function Delta({ value, isPositive = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <Typography
        fontSize={20}
        fontWeight={400}
        letterSpacing="0.01538em"
        lineHeight="24px"
        sx={{
          color: isPositive ? '#339900' : '#CC3300',
          display: value === '0.00%' ? 'none' : 'unset'
        }}
      >
        {`${isPositive ? '+' : ''}${value}`}
      </Typography>
      {value !== '0.00%' && (
        <>
          {isPositive ? (
            <TrendingUp sx={{ color: '#339900' }} />
          ) : (
            <TrendingDown sx={{ color: '#CC3300' }} />
          )}
        </>
      )}
      {value === '0.00%' && <Typography color={'#9F9F9F'}>N/A</Typography>}
    </Box>
  );
}

Delta.propTypes = {
  value: PropTypes.any.isRequired,
  isPositive: PropTypes.bool
};

export { Delta };
